import { useClientsContext } from 'contexts/ClientContext';

export const useAllClientsMap = () => {
  const { clientsMap, loading, error, refresh } = useClientsContext();
  return { clientsMap, loading, error, refresh };
};
